"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isWebLinkDef = exports.isDocumentLinkDef = exports.isAnyLinkDef = exports.isMediaLinkDef = exports.defaultLink = exports.LinkDef = void 0;
const tslib_1 = require("tslib");
const nestable_1 = require("@prismicio/types-internal/lib/customtypes/widgets/nestable");
const fp_ts_1 = require("fp-ts");
const function_1 = require("fp-ts/lib/function");
const t = tslib_1.__importStar(require("io-ts"));
const utils_1 = require("../../../utils");
const AnyLinkDef_1 = require("./AnyLinkDef");
const DocumentLinkDef_1 = require("./DocumentLinkDef");
const MediaLinkDef_1 = require("./MediaLinkDef");
const WebLinkDef_1 = require("./WebLinkDef");
const LinkConfig = t.union([MediaLinkDef_1.MediaLinkDef, DocumentLinkDef_1.DocumentLinkDef, WebLinkDef_1.WebLinkDef, AnyLinkDef_1.AnyLinkDef]);
const codec = t.strict({
    link: t.string,
    config: LinkConfig,
});
exports.LinkDef = new t.Type("LinkDef", (u) => (0, utils_1.isFieldDef)(u) && nestable_1.Link.is(u.def), (u) => {
    return (0, function_1.pipe)(codec.decode(u), fp_ts_1.either.map(({ link, config }) => {
        return {
            key: link,
            def: {
                type: "Link",
                config,
            },
        };
    }));
}, (l) => l);
function defaultLink(type) {
    const config = (() => {
        switch (type) {
            case "document":
                return (0, DocumentLinkDef_1.defaultDocumentLinkDef)();
            case "media":
                return (0, MediaLinkDef_1.defaultMediaLinkDef)();
            case "web":
                return (0, WebLinkDef_1.defaultWebLinkDef)();
            case null:
                return (0, AnyLinkDef_1.defaultAnyLinkDef)();
        }
    })();
    return {
        type: "Link",
        config,
    };
}
exports.defaultLink = defaultLink;
function isMediaLinkDef(def) {
    var _a;
    return def.type === "Link" && ((_a = def === null || def === void 0 ? void 0 : def.config) === null || _a === void 0 ? void 0 : _a.select) === "media";
}
exports.isMediaLinkDef = isMediaLinkDef;
function isAnyLinkDef(def) {
    var _a;
    return def.type === "Link" && ((_a = def === null || def === void 0 ? void 0 : def.config) === null || _a === void 0 ? void 0 : _a.select) === null;
}
exports.isAnyLinkDef = isAnyLinkDef;
function isDocumentLinkDef(def) {
    var _a;
    return def.type === "Link" && ((_a = def === null || def === void 0 ? void 0 : def.config) === null || _a === void 0 ? void 0 : _a.select) === "document";
}
exports.isDocumentLinkDef = isDocumentLinkDef;
function isWebLinkDef(def) {
    var _a;
    return def.type === "Link" && ((_a = def === null || def === void 0 ? void 0 : def.config) === null || _a === void 0 ? void 0 : _a.select) === "web";
}
exports.isWebLinkDef = isWebLinkDef;
tslib_1.__exportStar(require("./AnyLinkDef"), exports);
tslib_1.__exportStar(require("./DocumentLinkDef"), exports);
tslib_1.__exportStar(require("./MediaLinkDef"), exports);
tslib_1.__exportStar(require("./WebLinkDef"), exports);
